import { Component, Output, EventEmitter, Input, OnChanges, OnInit, ChangeDetectorRef } from '@angular/core';

import { TranslateService } from '@ngx-translate/core';
import { BzgModalRef, BzgModalService } from 'bz-genome-angular';
import { EJobType } from '../jobs/job-type.enum';
import * as _ from 'lodash';
import { SavePendingChangesComponent } from 'app/shared/components/save-pending-changes/save-pending-changes.component';
import { IUserJob } from '../core/IUserJob';
import { AIJobsService } from '../ai-jobs.service';
import { I18nService } from 'i18n/i18n.service';
import { ShowToastService } from 'app/shared/services/showToast.service';

@Component({
    selector: 'ai-jobs-description',
    templateUrl: 'ai-jobs-description.component.html',
    styleUrls: ['ai-jobs-description.component.scss']
})
export class AIJobsDescriptionComponent implements OnChanges {
    @Input() currentUserJob: IUserJob;
    @Output() cancel = new EventEmitter();
    @Output() resetEmit = new EventEmitter();
    @Output() userJobUpdate = new EventEmitter();

    public jobType: EJobType = EJobType.User;
    public modalRef: BzgModalRef;
    public job: IUserJob;

    constructor(private _AIJobService: AIJobsService,
        private _translateService: TranslateService,
        private _modalService: BzgModalService,
        private _i18nService: I18nService,
        private cdr: ChangeDetectorRef,
        private _showToastService: ShowToastService) { }

    ngOnChanges() {        
        this.job = _.cloneDeep(this.currentUserJob);
        this.cdr.detectChanges();
    }

    public async validatePendingChanges() {
        const isDateDifferent = new Date(this.currentUserJob.nextRuntime).getTime() !== new Date(this.job.nextRuntime).getTime();
        const isEnabledDifferent = this.currentUserJob.enabled !== this.job.enabled;

        if (isDateDifferent || isEnabledDifferent) {
            this.modalRef = this._modalService.open(SavePendingChangesComponent, {closeOnRouterNavigation: true});
            this.modalRef.afterClosed().subscribe(result => {
                switch (result.action) {
                    case 'cancel':
                        this.modalRef.close();
                        break;
                    case 'dontsave':
                        this.modalRef.close();
                        this.cancelAction();
                        break;
                    case 'save':
                        this.saveUserJob(this.job, true)
                        this.modalRef.close();
                        break;
                    case 'close':
                        this.modalRef.close();
                        break;
                }
            });
        } else {
            this.cancelAction();
        }
    }

    public async saveUserJob(userJob: any, closeAfter = false) { 
        this._AIJobService.update(userJob).subscribe((response) => {
            this.currentUserJob = userJob;
            this.userJobUpdate.emit(this.currentUserJob);
            if (closeAfter) {
                this.cancelAction();
            }
            this._showToastService.showToast(this._i18nService.instant('GLOBAL.THE_OPERATION_WAS_SAVED_SUCCESSFULLY'), 'success');
            this.reset();
        }, (error) => {
            this._showToastService.showToast(this._i18nService.instant('GLOBAL.AN_ERROR_HAS_OCCURRED'), 'error');
        });
    }

    public cancelAction() {
        this.cancel.emit();
    }

    public reset() {
        this.resetEmit.emit();
    }
}
